<template>
  <div class="oil-sample-graph-line">
    <Chart
      ref="oilSampleGraphLine"
      :options="options"
      :callback="createCustomLegendAndAddChartToData"
    />
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';
import StringHelperService from 'services/string-helper.service';
import GraphLegendMixin from 'mixins/GraphLegendMixin';
import GraphDataTransformationMixin from 'mixins/GraphDataTransformationMixin';
import Constants from '../../../constants/constants';

export default {
  name: 'OilSampleGraphLine',
  components: {
    Chart
  },
  mixins: [GraphLegendMixin, GraphDataTransformationMixin],
  props: {
    sampleData: {
      type: Array,
      required: true
    },

    sampleCount: {
      type: Number,
      required: true
    }
  },
  destroyed() {
    const { customLegend } = this.$parent.$refs;

    while (customLegend.firstChild) {
      customLegend.removeChild(customLegend.firstChild);
    }
  },
  data() {
    return {
      graphProps: Constants.Graph.OilSample.graphProps,
      legendGroups: Constants.Graph.OilSample.legendGroups,
      graphPercentProperties: Constants.Graph.OilSample.graphPercentProperties,
      unitSelectionStart: 0,
      categories: [],
      chart: null,
      options: {
        credits: {
          enabled: false
        },
        chart: {
          animation: false,
          backgroundColor: null,
          height: '55%',
          type: 'line'
        },
        colors: Constants.Graph.OilSample.graphProps.map(({ color }) => color),
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        legend: {
          enabled: false
        },
        tooltip: {
          pointFormatter() {
            return `<span style="color:${this.color}">●</span>
            ${Constants.Graph.OilSample.graphProps.find(prop => prop.name === this.series.name)
              ?.title || StringHelperService.fieldToTitle(this.series.name)}
            : <b>${this.y}</b><br/>`;
          }
        },
        xAxis: {
          categories: [],
          crosshair: true,
          reversed: true,
          title: {
            text: 'Sample Number & Date Received'
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Parts Per Million (ppm)'
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        series: []
      }
    };
  },
  computed: {
    selectionLowerBound() {
      return this.unitSelectionStart - 1 >= 0;
    },

    selectionUpperBound() {
      return this.unitSelectionStart + 1 <= this.sampleData.length - this.sampleCount;
    },

    highchartsFormattedDataWatchGroup() {
      return [this.highchartsFormattedData, this.unitSelectionStart, this.sampleCount];
    }
  },
  watch: {
    sampleData: {
      immediate: true,
      handler(value) {
        this.options.title.text = value[0].unitName;
        this.options.subtitle.text = `Customer: ${value[0].customerName}`;
        this.categories = [
          ...value.map(
            ({ sampleNumber, dateReceived }) =>
              `${sampleNumber}<br/>${this.formatTime(dateReceived)}`
          )
        ];
      }
    },

    sampleCount() {
      this.unitSelectionStart = 0;
    },

    highchartsFormattedDataWatchGroup: {
      immediate: true,
      handler() {
        this.options.xAxis.categories = this.categories.slice(
          this.unitSelectionStart,
          this.unitSelectionStart + this.sampleCount
        );

        this.options.series = this.highchartsFormattedData.map(({ name, data }) => {
          return {
            name,
            data: data.slice(this.unitSelectionStart, this.unitSelectionStart + this.sampleCount)
          };
        });
      }
    }
  },
  methods: {
    formatTime(value) {
      return value?.split('T')[0];
    },

    moveUnitSelection(moveForward) {
      if (!moveForward && !this.selectionUpperBound) return;
      if (moveForward && !this.selectionLowerBound) return;

      moveForward ? (this.unitSelectionStart -= 1) : (this.unitSelectionStart += 1);
    }
  }
};
</script>
